import React from 'react'
import { FaBullseye, FaChartBar, FaUsers, FaBookOpen, FaGlobe } from 'react-icons/fa'
import { FaRegHeart } from "react-icons/fa6";
import './DigiHealthLandingMissViss.css'

const DigiHealthLandingMissViss = () => {
  return (
    <section className="Digi-health-landing-miss-vis-section-bg">
      <div className="Digi-health-landing-miss-vis-section-container">
        <h2 className="Digi-health-landing-miss-vis-section-title">
          Our Vision & Mission
        </h2>
        <p className="Digi-health-landing-miss-vis-section-subtitle">
          Building a future-ready healthcare ecosystem that is evidence-driven, digitally inclusive, and ethically aligned with global standards.
        </p>
        <div className="Digi-health-landing-miss-vis-section-cards">
          {/* Vision Card */}
          <div className="Digi-health-landing-miss-vis-section-card Digi-health-landing-miss-vis-section-card-vision">
            <div className="Digi-health-landing-miss-vis-section-card-header">
              <span className="Digi-health-landing-miss-vis-section-card-icon Digi-health-landing-miss-vis-section-card-icon-vision">
                <FaBullseye />
              </span>
              <span className="Digi-health-landing-miss-vis-section-card-title">Vision</span>
            </div>
            <p className="Digi-health-landing-miss-vis-section-card-desc">
              To catalyze a future-ready healthcare ecosystem in India that is evidence-driven, digitally inclusive, and ethically aligned with global standards of care.
            </p>
          </div>
          {/* Mission Card */}
          <div className="Digi-health-landing-miss-vis-section-card Digi-health-landing-miss-vis-section-card-mission">
            <div className="Digi-health-landing-miss-vis-section-card-header">
              <span className="Digi-health-landing-miss-vis-section-card-icon Digi-health-landing-miss-vis-section-card-icon-mission">
                <FaRegHeart />
              </span>
              <span className="Digi-health-landing-miss-vis-section-card-title">Mission</span>
            </div>
            <ul className="Digi-health-landing-miss-vis-section-card-list">
              <li>
                <FaChartBar className="Digi-health-landing-miss-vis-section-list-icon" />
                Serve as a national resource hub for research, data analytics, and healthcare advancement insights
              </li>
              <li>
                <FaUsers className="Digi-health-landing-miss-vis-section-list-icon" />
                Facilitate cross-disciplinary collaboration between public and private stakeholders
              </li>
              <li>
                <FaBookOpen className="Digi-health-landing-miss-vis-section-list-icon" />
                Advocate for widespread adoption of national and international healthcare standards
              </li>
              <li>
                <FaGlobe className="Digi-health-landing-miss-vis-section-list-icon" />
                Function as a thought leadership platform guiding policy and system transformation
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DigiHealthLandingMissViss
